import { motion } from "framer-motion";
import { Reveal, Eyebrow, MaskLine } from "./Primitives";
import { EASE } from "../../lib/site";

const STEPS = [
  ["Aula experimental", "Você conhece o método na prática, sem compromisso, e conversamos sobre seus objetivos."],
  ["Avaliação & anamnese", "Histórico, rotina, limitações e metas — a base de tudo que vem depois."],
  ["Plano sob medida", "Um programa desenhado para o seu corpo, sua agenda e o resultado que você busca."],
  ["Acompanhar & ajustar", "Evolução medida, ajustes constantes e progressão segura até o objetivo."],
];

export const Method = () => (
  <section id="metodo" className="relative border-t border-white/10 bg-[var(--ink-2)] px-5 py-24 md:px-10 md:py-32" data-testid="method-section">
    <div className="mx-auto grid max-w-[1400px] gap-14 lg:grid-cols-12">
      <div className="lg:col-span-5">
        <div className="lg:sticky lg:top-32">
          <Eyebrow index="03">Método</Eyebrow>
          <h2 className="mt-8 font-display text-5xl font-900 uppercase leading-[0.9] sm:text-6xl lg:text-8xl">
            <MaskLine inView>Do primeiro</MaskLine>
            <MaskLine inView delay={0.1}>treino ao</MaskLine>
            <MaskLine inView delay={0.2}><span className="text-[var(--red)]">resultado.</span></MaskLine>
          </h2>
          <Reveal delay={0.2}>
            <div className="clip-slant mt-10 hidden aspect-[16/10] overflow-hidden lg:block">
              <img src="/img/metodo.jpg" alt="Mulher fazendo levantamento terra em academia" className="h-full w-full object-cover" />
            </div>
          </Reveal>
        </div>
      </div>
      <ol className="lg:col-span-7">
        {STEPS.map(([t, d], i) => (
          <li key={t} className="group relative border-b border-white/10 py-10 first:pt-0 md:py-14" data-testid={`method-step-${i + 1}`}>
            <motion.span initial={{ scaleX: 0 }} whileInView={{ scaleX: 1 }} viewport={{ once: true, amount: 0.5 }}
              transition={{ duration: 1.2, ease: EASE }} className="absolute bottom-[-1px] left-0 h-px w-full origin-left bg-[var(--red)]" />
            <Reveal className="grid grid-cols-[auto_1fr] gap-6 md:gap-12">
              <span className="font-display text-6xl font-900 leading-none text-outline transition-colors duration-500 group-hover:text-[var(--red)] md:text-8xl">0{i + 1}</span>
              <div className="pt-2">
                <h3 className="font-display text-3xl font-800 uppercase md:text-5xl">{t}</h3>
                <p className="mt-3 max-w-md text-base leading-relaxed text-zinc-400">{d}</p>
              </div>
            </Reveal>
          </li>
        ))}
      </ol>
    </div>
  </section>
);
